import React from 'react'
import { networkLogos } from 'src/constants/networkLogos'
import { sportIds, leagueIds, teamIds, PlanTypes } from 'src/constants'
import USTemplateDefault from 'src/components/template/us'
import FuboFreeTemplate from 'src/components/template/fubofree'
import { useIsRSNAvailable } from 'src/modules/hooks/useIsRSNAvailable'
import { usPlanData } from 'src/constants/planData/usPlanData'

export default (props) => {
  const { isAvailable } = useIsRSNAvailable(PlanTypes.CHICAGO_SPORTS_NETWORK)
  const commonProps = {
    location: props.location,
    video: 'https://assets.fubo.tv/marketing/lp/videos/compressed/WhiteSox_Web_LP_10s.mp4',
    videoMobile: 'https://assets.fubo.tv/marketing/lp/videos/mobile/WhiteSox_Mobile_LP_10s.mp4',
    staticAnnotation: networkLogos.chsn,
    title: 'Watch Chicago baseball live',
    subtitle: 'Stream the White Sox on Chicago Sports Network',
    networkSet: 'baseball',
    networkHeadline: 'The Best of Sports from the Channels You Love',
    customNetworks: ['chsn'],
    sportId: sportIds.Baseball,
    leagueId: leagueIds.MLB,
    teamId: teamIds['Chicago White Sox'],
  }

  return isAvailable ? (
    <FuboFreeTemplate
      {...commonProps}
      hasPlanCards={isAvailable}
      plans={[usPlanData.chicago_sports_network_monthly, usPlanData.pro_standalone_monthly]}
      plansSharedData={{
        teams: usPlanData.chicago_sports_network_monthly.teams,
      }}
      faqListOverride={faqListOverride}
    />
  ) : (
    <USTemplateDefault {...commonProps} />
  )
}

const faqListOverride = [
  {
    question: 'How can I find Chicago Bulls games on Fubo?',
    answer:
      'To find Chicago Bulls games on Fubo, use the search feature or check the schedule for Chicago Sports Network, which broadcasts Bulls games live.',
  },
  {
    question: 'Where can I watch Chicago Blackhawks games without cable?',
    answer:
      'You can watch Chicago Blackhawks games without cable on Fubo via Chicago Sports Network, which provides live coverage of Bulls games.',
  },
  {
    question: 'Can I watch MLB games on Fubo?',
    answer:
      'Yes, Fubo offers MLB games through channels like ESPN and regional sports networks, allowing you to enjoy live baseball action throughout the season.',
  },
  {
    question: 'How do I find Chicago White Sox games on Fubo?',
    answer:
      'To find Chicago White Sox games on Fubo, check the schedule for Chicago Sports Network where you can watch live broadcasts of the games.',
  },
  {
    question: 'Does Fubo provide commentary and analysis for NBA games?',
    answer:
      'Yes, Fubo includes channels that offer commentary and analysis for NBA games, enhancing your viewing experience with expert insights.',
  },
  {
    question: 'Can I watch pre-game and post-game shows for the Chicago Bulls on Fubo?',
    answer:
      'Yes, Fubo provides access to pre-game and post-game shows for the Chicago Bulls on Chicago Sports Network, giving you comprehensive coverage of each game.',
  },
  {
    question: 'Are there any related shows for Chicago sports on Fubo?',
    answer:
      'Yes, Fubo offers various related shows and analysis programs for Chicago sports, available on channels including Chicago Sports Network, ensuring you stay updated on your favorite teams.',
  },
]
